(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oja-ritual-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSlider = (track) => {
      if (!track || track.dataset.ojaRitualSliderInit === 'true') return;
      track.dataset.ojaRitualSliderInit = 'true';

      const slider = track.closest('.oja-ritual__slider');
      const prevButton = slider?.querySelector('[data-oja-ritual-prev]');
      const nextButton = slider?.querySelector('[data-oja-ritual-next]');

      let pointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let moved = false;
      let suppressClick = false;

      const updateNavigation = () => {
        if (!prevButton || !nextButton) return;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        prevButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft >= maxScroll - 2 || maxScroll <= 2;
      };

      const getScrollStep = () => {
        const card = track.querySelector('.oja-ritual__card');
        if (!card) return track.clientWidth * 0.75;
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      };

      prevButton?.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });

      nextButton?.addEventListener('click', () => {
        track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateNavigation, { passive: true });
      window.addEventListener('resize', updateNavigation, { passive: true });

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        moved = false;
      });

      track.addEventListener('pointermove', (event) => {
        if (pointerId !== event.pointerId) return;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 5) {
          moved = true;
          track.classList.add('is-dragging');
          if (!track.hasPointerCapture(pointerId)) track.setPointerCapture(pointerId);
        }
        if (moved) track.scrollLeft = startScrollLeft - delta;
      });

      const endDrag = (event) => {
        if (pointerId !== event.pointerId) return;
        suppressClick = moved;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId);
        pointerId = null;
        window.setTimeout(() => {
          suppressClick = false;
        }, 0);
      };

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener(
        'click',
        (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );

      updateNavigation();
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-oja-ritual-slider]').forEach(initSlider);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
